<template>
    <CRow class="mt-3">
        <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto">
            <div class="p-2 b-a-2 bg-white">
                <h1 class="font-lg font-weight-bold text-center mt-2 b-b-1 pb-2 text-danger">چه رسانه‌هایی مورد تایید افیلی است؟</h1>
                <p>اگر رسانه‌ای با شرایط زیر دارید اقدام به ثبت آن نمایید در غیر اینصورت از این مرحله رد شوید.</p>


                <h6>پیج‌های اینستاگرام، کانال‌های تلگرام و واتساپ</h6>
                <span class="bg-primary w-100 d-block mb-4" style="height:2px"></span>
                <div>
                    <p> <span class="font-weight-bold font-lg">1.</span> <span>از زمان تاسیس رسانه باید حداقل سه ماه گذشته باشد.</span> </p>
                    <p> <span class="font-weight-bold font-lg">2.</span> <span>وجود حداقل 1,000 عضو واقعی برای رسانه الزامی است.</span> </p>
                    <p> <span class="font-weight-bold font-lg">3.</span> <span>گروه‌های واتساپ و تلگرام مورد تایید نمی‌باشند.</span> </p>
                    <p> <span class="font-weight-bold font-lg">4.</span> <span>رسانه باید فعالیت مداوم و مستمر داشته باشد.</span> </p>
                    <p> <span class="font-weight-bold font-lg">6.</span> <span>وجود حداقل ۲۰ محتوای با کیفیت جهت تایید رسانه الزامی است.</span> </p>
                    <p> <span class="font-weight-bold font-lg">7.</span> <span>رسانه باید به صورت عمومی قابل دسترسی باشد.</span> </p>
                </div>

                <h6>وبلاگ‌ها و وبسایت‌ها</h6>
                <span class="bg-primary w-100 d-block mb-4" style="height:2px"></span>
                <div>
                    <p> <span class="font-weight-bold font-lg">1.</span> <span>رسانه از رابط کاربری خوبی برخوردار باشد</span> </p>
                    <p> <span class="font-weight-bold font-lg">2.</span> <span>برای وبلاگ‌ها وجود حداقل 10 مقاله با کیفیت الزامی است.</span> </p>
                    <p> <span class="font-weight-bold font-lg">3.</span> <span>رسانه باید حداقل 1,000 ورودی در ماه داشته باشد. (مستندات مربوطه از طریق پشتیبانی از شما گرفته می‌شود)</span> </p>
                    <p> <span class="font-weight-bold font-lg">4.</span> <span>رسانه باید فعالیت مداوم و مستمر داشته باشد.</span> </p>
                </div>
            </div>

            <ValidationObserver class="p-2 b-a-2 bg-white" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
                <Loading />
                <Message />

                <span v-if="medium.rejection_reason" class="alert alert-warning d-block">{{ medium.rejection_reason }}</span>

                <CForm method="post" @submit.prevent="handleSubmit(submit)">
                    <CRow>
                        <CCustomSelect
                            sm="12"
                            v-model="medium.type"
                            :options="mediaTypeOption"
                            vid="type"
                            required
                            asInt
                            rules="required"
                            :name="$t('media.type')"
                        />

                        <CCustomInput
                            sm="12"
                            vid="name"
                            :name="$t('media.name')"
                            rules="required"
                            required
                            v-model="medium.name"
                            :placeholder="$t('media.placeholders.name')"
                        />

                        <CCustomInput
                            sm="12"
                            vid="url"
                            :name="$t('media.url')"
                            rules="required|url"
                            required
                            ltr
                            v-model="medium.url"
                            :placeholder="$t('media.placeholders.url')"
                        />

                        <CCol col="12" class="b-t-1 pt-2 mt-3">
                            <CButton :disabled="invalid" type="submit"  color="primary" class="px-4 float-right">{{ $t('btn.next_step') }}</CButton>
                            <CButton type="button" @click="prev" color="outline-primary" class="px-4">{{ $t('btn.prev_step') }}</CButton>
                            <CButton color="link" class="float-lg-right text-muted not-focusable" @click="nxt">رد شدن</CButton>
                        </CCol>
                    </CRow>
                </CForm>
            </ValidationObserver>
        </CCol>
    </CRow>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { firstIndex } from '@/common/objects'
import { mediaTypeOption } from '@/common/data'
import { MediaStatus, UserSetupStatus } from '@/constants'
import { mediaStatusStr } from '@/views/media/partials/methods'

export default {
    name: 'SubmitMedia',

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('media/fetch')
        })
    },

    data() {
        return {
            MediaStatus,
            setMedium: false,
            mediaTypeOption
        }
    },

    computed: {
        ...mapGetters({
            media: 'media/media'
        }),
        user() {
            return this.$currentUser()
        },
        medium() {
            return firstIndex(this.media) || {
                name: '',
                url: '',
                type: '0',
                rejection_reason: '',
                status: MediaStatus.PENDING
            }
        }
    },

    methods: {
        mediaStatusStr,
        ...mapActions({
            create: 'media/create',
            edit: 'media/edit',
            setShowLoading: 'loadingComponent/setShowLoading',
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
        }),
        submit() {
            const data = {
                id: this.medium.id,
                name: this.medium.name,
                type: this.medium.type,
                url: this.medium.url,
            }

            this.setShowLoading()

            const func = data.id ? this.edit : this.create

            func(data).then(() => {
                this.changeCurrentUserSetupStatus(UserSetupStatus.ACTIVITY_AREA).then(() => {
                    this.setShowLoading(false)
                })
            }).catch(result => {
                if(result.data) {
                    this.$refs.form.setErrors(result.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
        nxt() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.ACTIVITY_AREA).then(() => {
                this.setShowLoading(false)
            })
        },
        prev() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.FINANCIAL_INFO).then(() => {
                this.setShowLoading(false)
            })
        }
    }
}
</script>
